export enum ADMIN_TAGS_TYPE {
    normal = 'normal',
    education = 'education'
}export enum ADMIN_TAGS_TYPE {
    normal = 'normal',
    education = 'education'
}